import Hero from "@/components/sections/Hero";
import WhySeed from "@/components/sections/WhySeed";
import Marquee from "@/components/Marquee";
import WhatPeopleLearn from "@/components/sections/WhatPeopleLearn";
import LearningPathwaysHome from "@/components/sections/LearningPathwaysHome";
import WhoForInquiry from "@/components/sections/WhoForInquiry";
import OnCountryFeature from "@/components/sections/OnCountryFeature";
import SeedBankFeature from "@/components/sections/SeedBankFeature";
import Facilitators from "@/components/sections/Facilitators";
import StewardshipIntelligence from "@/components/sections/StewardshipIntelligence";
import IndigenousKnowledge from "@/components/sections/IndigenousKnowledge";
import FinalCTAAcademy from "@/components/sections/FinalCTAAcademy";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <WhySeed />
      <div className="bg-cream text-rainforest">
        <Marquee text="Native Seed Collection • Seed Banking • Propagation • Restoration Supply • On-Country Learning • Ranger Development • Seed Enterprises • Fire Recovery • Mine Rehabilitation • Biodiversity Restoration" />
      </div>
      <WhatPeopleLearn />
      <LearningPathwaysHome />
      <OnCountryFeature />
      <WhoForInquiry />
      <SeedBankFeature />
      <StewardshipIntelligence />
      <IndigenousKnowledge />
      <Facilitators />
      <FinalCTAAcademy />
    </div>
  );
}
